<app-crudbar-nav [title]="title" (onReady)="doComReady($event,'crudbar-nav')">
</app-crudbar-nav>

<mat-tab-group #masterTabGroup mat-stretch-tabs="false" mat-align-tabs="start"
  class="h-full"
  style="vertical-align: top;" animationDuration="0ms" dynamicHeight
  (selectedTabChange)="onMasterTabChange($event)">
  <mat-tab #myTabGrid label="瀏覽">
    <div class="border-2 border-red-300">
      <app-jkaggrid #myGrid  [columnDefs]="srv.columnDefs" 
        (afterGridReadyAg)="afterGridReady($event)" (rowClicked)="agRowClicked($event)"
        (rowSelected)="agRowSelected($event)" (onInsert)="doUIInsert($event)"
        (onDelete)="doUIDelete($event)"></app-jkaggrid>

    </div>
  </mat-tab>

  <mat-tab #myTabDetail label="明細">
    <!-- <app-utysc-tabedit [srv]="srv"></app-utysc-tabedit> -->
    <div style="max-height: 400px; overflow-y: auto;">
      <div class="jk-grid-cols-2">
          <app-jktext  label="主資料表" [value]="item.SC001"     >
    </app-jktext>
    <app-jktext  label="序號" [value]="item.SC002"     >
    </app-jktext>
    <app-jktext  label="使用者代號" [value]="item.SC003"     >
    </app-jktext>
    <app-jktext  label="保留" [value]="item.SC004"     >
    </app-jktext>
    <app-jktextarea  height="250px" 
 label="備註" #SC005Com  id="SC005"  [(value)]="item.SC005" [readonly]="true"     >
    </app-jktextarea>

      </div>
    </div>
  </mat-tab>


  <mat-tab #myTabAdvance label="進階">
    <div class="border-2 min-h-[200px]">[空白]</div>
  </mat-tab>
</mat-tab-group>